import React from "react";
import "./Contact.css";

export default function Contact() {
  return (
    <section id="contact" className="contact">
      <h2 className="contact-title">Kontakt</h2>

      <p className="contact-subtitle">
        Sie haben Fragen zu Energieberatung, Energieausweisen oder
        Fördermöglichkeiten? Kontaktieren Sie uns gerne.
      </p>

      <div className="contact-grid">

        <div className="contact-card">
          <div className="contact-header">
            <div className="contact-icon">✉️</div>
            <h3>E-Mail</h3>
          </div>

          <p>
            Schreiben Sie uns gerne eine E-Mail mit Ihrem Anliegen.
            Wir melden uns schnellstmöglich bei Ihnen zurück.
          </p>

          <a href="mailto:info@suw-ing.de" className="contact-link">
            info@suw-ing.de
          </a>
        </div>


        <div className="contact-card">
          <div className="contact-header">
            <div className="contact-icon">📞</div>
            <h3>Telefon</h3>
          </div>

          <p>
            Für eine direkte Beratung erreichen Sie uns telefonisch.
            Sollten Sie uns einmal nicht direkt erreichen, hinterlassen
            Sie gerne Ihr Anliegen sowie Ihre Kontaktdaten – wir melden
            uns schnellstmöglich bei Ihnen zurück.
          </p>

          <a href="tel:+49 (0)261 94297645" className="contact-link">
            +49 261 94297645
          </a>
        </div>

      </div>
    </section>
  );
}